export const RUNS_ENDPOINTS = {
    SEARCH: '/runs/search',
} as const;
